import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CurrencyPipe, isPlatformBrowser } from '@angular/common';

import { ToasterService, Toast, ToasterConfig } from 'angular2-toaster';
import { BehaviorSubject, Subscription } from 'rxjs';

import { ApplicationStateService } from '../services/application-state.service';
import { QuoteApprovalService } from '../services/quote-approval.service';
import { QuoteService } from '../services/quote.service';
import { OptionsService } from '../services/options.service';
import { AdjustmentService } from '../services/adjustments.service';
import { LoadingSpinnerService } from '../services/loading-spinner.service';
import { PageTitleService } from '../services/page-title.service';
import { QuoteInfoService } from '../services/quote-info.service';
import { CurrentUserService } from '../services/current-user.service';
import { QuoteSummaryService } from '../services/quote-summary.service';
import { ModalDialogService } from '../reusable-components/modal-dialog/modal-dialog.service';
import { BrowserWidthService } from '../services/browser-width.service';
import { HttpResponseService } from '../services/httpresponse-service';
import { QuoteRevisionService } from '../services/quote-revision.service';
import { QuoteRevisionInfoService } from '../services/quote-revision-info.service';

import { CookieService } from 'angular2-cookie/services/cookies.service';

import { WordCasePipe } from '../pipes/word-case.pipe';
import { PhonePipe } from '../pipes/phone-number.pipe';
import { SixDigitsPipe } from '../pipes/six-digits.pipe';

import { SelectedOption } from '../model/selected-option';
import { QuoteSummary } from '../model/quote-summary';
import { Quote } from '../model/quote';
import { Adjustment } from '../model/adjustment';
import { Constants } from '../model/constants';
import { throwErrorToast } from '../utilities/lang';
import { CurrentUser } from '../model/current-user';
import { Option } from '../model/option';

import * as _ from 'lodash';

@Component({
  selector: 'my-quote-summary',
  template: require('./quote-summary.component.html'),
  styles: [require('./quote-summary.component.scss')]
})
export class QuoteSummaryComponent implements OnInit, OnDestroy {
  pdfMake: any = window['pdfMake'];
  quoteId: number;
  iseriesQuoteNumber: number;
  currentPricingView: number;
  defaultPdfFontSize = 8;
  subOptionPdfFontSize = this.defaultPdfFontSize + 1;
  mediumPdfFontSize = 10;
  largePdfFontSize = 11;
  orderQuantity: number = 1;
  currentUserId: number;

  stateError: string = '';
  emails: string;
  pdfWatermark: string = Constants.waterMarkBase64;
  transparentPlaceholderImg: string =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
  retailerName: string;
  retailerNumber: string;
  submitQuoteAddress: string;
  mchBaseUrl: string;
  waterMarkUrl: string = Constants.waterMarkBase64;
  quoteApprovalNote: string = '';
  quoteExpirationDate: string = null;
  declinedReason: string;
  currentUserRoles: Array<string> = [];
  overrideIssues: string[];
  username: string;

  stateIsInvalid: boolean = false;
  showEmailPage: boolean;
  isApproved: boolean = false;
  disableButton: boolean = false;
  isReadOnly: boolean = false;
  showSubmitModal: boolean = false;
  validSubmitQuoteAddress: boolean = true;
  isSubOption: boolean = false;
  showSubmitForApprovalModal: boolean;
  isRetailerUser: boolean;
  showDeclineQuoteModal: boolean;
  isQuoteApprover: boolean = false;
  isQuoteOverrideApprover: boolean = false;
  showApproverOverrides: boolean = false;
  showApprovalModal: boolean = false;
  mustOverrideApproval: boolean = false;
  isvalidExpirationDate: boolean = true;
  invalidApprovalData: boolean = false;
  hideApprovalButtons: boolean = false;
  throwErrorForTesting: boolean = false;
  disableApproval: boolean = false;

  _quoteSummaryCache: QuoteSummary = new QuoteSummary();
  quoteSummary: QuoteSummary = new QuoteSummary();
  customerId;
  optionsArray: Array<any> = new Array();
  config: ToasterConfig = new ToasterConfig({
    positionClass: 'toast-bottom-right'
  });
  toast: Toast;
  quoteAdjustment: Adjustment;
  pdf: any;
  base64Pdf: BehaviorSubject<any> = new BehaviorSubject(null);
  customOptions: SelectedOption[];
  throwErrorToast = throwErrorToast;
  subscription: Subscription = new Subscription();
  currentUser: CurrentUser;
  allNormalOptions: Array<Option>;
  modelId: number;

  public phoneMask = [
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/
  ];

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public applicationStateService: ApplicationStateService,
    public quoteService: QuoteService,
    public optionsService: OptionsService,
    public toasterService: ToasterService,
    public adjustmentService: AdjustmentService,
    public spinner: LoadingSpinnerService,
    public pageTitleService: PageTitleService,
    public quoteInfoService: QuoteInfoService,
    public wordCasePipe: WordCasePipe,
    public phoneNumberPipe: PhonePipe,
    public sixDigitsPipe: SixDigitsPipe,
    public currentUserService: CurrentUserService,
    public modalDialogService: ModalDialogService,
    public cookieService: CookieService,
    public quoteApprovalService: QuoteApprovalService,
    public browserWidthService: BrowserWidthService,
    public quoteSummaryService: QuoteSummaryService,
    public httpResponseService: HttpResponseService,
    public currencyPipe: CurrencyPipe,
    public quoteRevisionService: QuoteRevisionService,
    private quoteRevisionInfoService: QuoteRevisionInfoService
  ) {
    const routeParamsSub = this.route.params.subscribe(x => {
      this.quoteId = x['quoteId'];
      this.quoteInfoService.quoteId$.next(this.quoteId);
    });
    this.subscription.add(routeParamsSub);
    this.pageTitleService.pageTitle.next({
      title: Constants.CmhConnectionTitle
    });

    const currentUserSub = this.currentUserService.currentUser$.subscribe(
      cu => {
        this.currentUser = cu;
        if (cu.roles !== undefined && cu.roles.length > 0) {
          this.currentUserRoles = cu.roles;
          this.isReadOnly =
            cu.roles.find(cmhRole => cmhRole === 'MyCustomHomes') === undefined
              ? true
              : false;
          this.isQuoteApprover =
            cu.roles.find(
              cmhRole => cmhRole === 'MyCustomHomes_Quote_Approver'
            ) === undefined
              ? false
              : true;
          this.isQuoteOverrideApprover =
            cu.roles.find(
              cmhRole => cmhRole === 'MyCustomHomes_OverrideApprover'
            ) === undefined
              ? false
              : true;
        }
        this.applicationStateService.setCmhUser(cu);
        this.currentUserId = cu.cmhUserId || cu.CmhUserId;
        this.username = cu.fullName;
        this.retailerNumber = cu.retailerNumber;
      }
    );
    this.subscription.add(currentUserSub);
    this.mchBaseUrl = this.cookieService.get('mchBaseUrl');
    this.hideApprovalButtons = false;

    if (this.cookieService.get('Bearer') === undefined) {
      // bearer cookie doesn't exist therefore reroute to login
      window.location.href =
        '/web/#!/login/expired?returnUrl=' + window.location.pathname;
    }
  }

  /// Gets the current quote or refreshes the current quote from the db. Then loads the page
  ngOnInit() {
    // Get number of revisions by quoteId
    const qVersions = this.quoteRevisionService
      .getQuoteRevisionsByQuote(this.quoteId)
      .subscribe(data => {
        if (data !== undefined && data !== null) {
          this.quoteRevisionInfoService._quoteRevisions$.next(data);
        }
      });
    this.subscription.add(qVersions);

    const allNormalOptionsSub = this.optionsService.allNormalOptions$.subscribe(
      x => {
        this.allNormalOptions = x;
      }
    );
    this.subscription.add(allNormalOptionsSub);
    const quoteSub = this.quoteInfoService.quote$.subscribe(
      x => (this.modelId = x.modelId)
    );
    this.subscription.add(quoteSub);
    this.spinner.showSpinner();
    this.currentPricingView = this.applicationStateService.pricingView;
    const optionsChangedSub = this.optionsService.optionsChanged$.subscribe(
      optionsChanged => {
        if (optionsChanged === false) {
          if (this.quoteId === undefined || this.quoteId === 0) {
            this.spinner.hideSpinner();
            this.stateIsInvalid = true;
            this.modalDialogService
              .showMessage({
                headerText: 'Quote Summary',
                message: Constants.NewQuoteMessage
              })
              .subscribe(messageReply => {
                this.redirectRequired(true, false, false);
              });
          } else {
            const refreshStateFromDB = this.applicationStateService
              .refreshStateFromDB(this.quoteId)
              .subscribe(
                dbQuote => {
                  if (dbQuote !== undefined && dbQuote !== null) {
                    this.iseriesQuoteNumber = dbQuote.iseriesQuoteNumber;
                    this.applicationStateService.setQuote(dbQuote);
                    this.quoteInfoService.quote$.next(dbQuote);
                    const canAccessQuoteSub = this.quoteInfoService.canAccessQuote$
                      .take(1)
                      .subscribe(canAccessQuote => {
                        if (canAccessQuote === true) {
                          if (
                            dbQuote.productLineId === undefined ||
                            dbQuote.productLineId === null ||
                            dbQuote.productLineId === 0
                          ) {
                            this.spinner.hideSpinner();
                            this.modalDialogService
                              .showMessage({
                                headerText: Constants.NoProductLineHeader,
                                message: Constants.NoProductLineMessage
                              })
                              .subscribe(messageReply => {
                                this.redirectRequired(false, true, false);
                              });
                          } else {
                            if (
                              dbQuote.modelId === undefined ||
                              dbQuote.modelId === null ||
                              dbQuote.modelId === 0
                            ) {
                              this.spinner.hideSpinner();
                              this.modalDialogService
                                .showMessage({
                                  headerText: Constants.NoModelHeader,
                                  message: Constants.NoModelMessage
                                })
                                .subscribe(messageReply => {
                                  this.redirectRequired(false, false, true);
                                });
                            } else {
                              const adjustmentSub = this.adjustmentService
                                .getAdjustmentByQuote(this.quoteId)
                                .subscribe(x => {
                                  this.quoteAdjustment =
                                    x === undefined ? new Adjustment() : x;
                                  this.loadPage();
                                });
                              this.subscription.add(adjustmentSub);
                            }
                          }
                        } else {
                          this.spinner.hideSpinner();
                        }
                      });
                    this.subscription.add(canAccessQuoteSub);
                  } else {
                    this.spinner.hideSpinner();
                    this.stateIsInvalid = true;
                    this.modalDialogService
                      .showMessage({
                        headerText: 'Quote Summary',
                        message: Constants.QuoteNotFoundMessage.replace(
                          '#quoteid#',
                          this.quoteId.toString()
                        )
                      })
                      .subscribe(messageReply => {
                        this.redirectRequired(true, false, false);
                      });
                  }
                },
                error => {
                  this.spinner.hideSpinner();
                  this.httpResponseService.httpErrorResponse$.next(error);
                }
              );
            this.subscription.add(refreshStateFromDB);
          }
        } else {
          this.spinner.showSpinner();
        }
      }
    );
    this.subscription.add(optionsChangedSub);

    const currentPricingViewSub = this.quoteInfoService.currentPricingView$.subscribe(
      x => {
        this.currentPricingView = x;
        let quote = this.applicationStateService.getQuote();
        if (quote.modelId > 0) {
          this.calculatePricing(this._quoteSummaryCache, this.quoteAdjustment);
        }
      }
    );
    this.subscription.add(currentPricingViewSub);
  }

  ngOnDestroy() {
    this.disableApproval = false;
    this.subscription.unsubscribe();
  }

  /// Saves the quote to the db when the Save Quote button is clicked
  saveQuote() {
    this.spinner.showSpinner();
    let quote: Quote = new Quote();
    quote = this.applicationStateService.getApplicationState().quote;

    if (this.quoteSummary.DateCreated === null) {
      quote.DateCreated = new Date();
    } else {
      quote.DateCreated = this.quoteSummary.DateCreated;
    }
    quote.LastModifiedDate = new Date();

    this.quoteService.updateQuote(quote).subscribe(x => {
      this.spinner.hideSpinner();
      this.toasterService.pop('success', 'Success!', 'Quote has been saved');
    });
  }

  /// Loads the page
  loadPage() {
    // if this is a non-MCH user change the pricing view to no pricing.
    if (!this.currentUser.isMCHUser) {
      this.applicationStateService.setPricingView(3);
      this.quoteInfoService.currentPricingView$.next(3);
    }

    let quote = this.applicationStateService.getQuote();
    this.quoteId = quote.quoteId;
    this.customerId = quote.customerId || 1;
    if (quote.modelId && quote.modelId !== null && quote.modelId > 0) {
      if (this.currentUser.isMCHUser) {
        this.quoteService
          .getQuoteSummary(+this.quoteId, this.customerId)
          .subscribe(
            x => {
              this.quoteSummary = x;
              if (
                this.iseriesQuoteNumber > 0 &&
                this.quoteSummary.QuoteStatusesID > 0
              ) {
                this.quoteSummary.QuoteId = this.iseriesQuoteNumber;
                this.pageTitleService.pageTitle.next({
                  title: Constants.CmhConnectionTitle,
                  subTitle:
                    Constants.CurrentQuoteSubTitle + this.iseriesQuoteNumber
                });
              } else {
                this.pageTitleService.pageTitle.next({
                  title: Constants.CmhConnectionTitle,
                  subTitle: Constants.CurrentQuoteSubTitle + this.quoteId
                });
              }
              this.isApproved =
                this.quoteSummary.QuoteStatusesID === 3 ? true : false;
              this.quoteSummary.CustomerName = x.CustomerName;
              this.quoteSummary.FacilityLogo =
                this.quoteSummary.FacilityLogo !== ''
                  ? this.quoteSummary.FacilityLogo
                  : this.getBase64Logo();
              this.quoteSummary.CategoryNames.forEach(cat => {
                var categoryMessage = new Array<string>();
                this.quoteSummary.ModelCategoryMessages.filter(
                  mcm => mcm.CategoryName === cat
                ).forEach(cm => {
                  categoryMessage.push(cm.MessageText.join(', '));
                });
                let messageText = '';
                this.optionsArray.push({
                  category: cat,
                  options: this.quoteSummary.Options.filter(
                    op => op.CategoryName === cat
                  ),
                  categoryMessages: this.quoteSummary.ModelCategoryMessages.filter(
                    mcm => mcm.CategoryName === cat
                  ).map(a => a.MessageText.join(', '))
                });
              });
              this._quoteSummaryCache = _.cloneDeep(this.quoteSummary);
              this.calculatePricing(
                this._quoteSummaryCache,
                this.quoteAdjustment
              );
              this.browserWidthService.modalActive$.next(false);
            },
            error => {
              this.spinner.hideSpinner();
              this.httpResponseService.httpErrorResponse$.next(error);
            },
            () => {
              this.spinner.hideSpinner();
            }
          );
      } else {
        this.quoteService
          .getQuoteSummaryNoPricing(+this.quoteId, this.customerId)
          .map(x => {
            this.quoteSummary = x;
            this.quoteSummary.CustomerName = this.quoteInfoService.quoteSummary$.value.CustomerName;
            this.quoteSummary.FacilityLogo =
              this.quoteSummary.FacilityLogo !== ''
                ? this.quoteSummary.FacilityLogo
                : this.getBase64Logo();
            this.quoteSummary.CategoryNames.forEach(cat => {
              this.optionsArray.push({
                category: cat,
                options: this.quoteSummary.Options.filter(
                  op => op.CategoryName === cat
                )
              });
            });
            this._quoteSummaryCache = _.cloneDeep(this.quoteSummary);
            this.calculatePricing(
              this._quoteSummaryCache,
              this.quoteAdjustment
            );
            this.browserWidthService.modalActive$.next(false);
          })
          .subscribe(
            data => {},
            error => {
              this.spinner.hideSpinner();
              this.httpResponseService.httpErrorResponse$.next(error);
            },
            () => {
              this.spinner.hideSpinner();
            }
          );
      }
    } else {
      this.spinner.hideSpinner();
      this.browserWidthService.modalActive$.next(false);
    }
  }

  goToCategory(cat: string) {
    if (!this.isReadOnly) {
      let catId = this.quoteSummary.Categories.find(x => {
        return x.CategoryName === cat;
      }).CategoryId;
      this.router.navigate(['options-configuration', this.quoteId, catId]);
    }
  }

  /// Gets the Subtotal for each Option Category
  getSubtotal(options: SelectedOption[]): number {
    let subtotal = 0;
    options.forEach(op => {
      subtotal += op.AdjustedTotalPrice;
    });
    return subtotal;
  }

  get consolidatedPricing() {
    return (
        (this.quoteSummary.BaseCost + this.quoteSummary.PartnerAssistanceAmount + this.quoteSummary.VIPAmount) +
      this.quoteSummary.Taxes +
      this.quoteSummary.Dues   
    );
  }

  get approvalStatusMessage() {
    let msg: string;
    if (this.quoteSummary) {
      switch (this.quoteSummary.QuoteStatusesID) {
        case 0:
          msg = '';
          break;

        case 1:
          msg = 'Pending Approval';
          break;

        case 2:
          msg = 'Quote Declined By Facility';
          break;

        case 3:
          msg = 'Quote Approved By Facility';
          break;
      }
    }
    return msg;
  }

  get approvalStatusMessageStyle() {
    let style: string;
    if (this.quoteSummary) {
      switch (this.quoteSummary.QuoteStatusesID) {
        case 0:
          style = 'white';
          break;

        case 1:
          style = '#F0AD4E';
          break;

        case 2:
          style = '#F02128';
          break;

        case 3:
          style = '#27AF4D';
          break;
      }
    }
    return style;
  }

  /// Hides all prices when No Pricing is selected in the menu
  changeNoPricing() {
    if (this.quoteSummary.NoPricing) {
      this.quoteSummary.NoPricing = false;
    } else {
      this.quoteSummary.NoPricing = true;
    }
  }

  get showSubmitButton() {
    let show: boolean = false;
    let isPlantUser: boolean;
    const currentUserSub = this.currentUserService.currentUser$.subscribe(x => {
      this.isRetailerUser = !x.isPlantUser;
      isPlantUser = x.isPlantUser;
    });
    if (
      this.quoteSummary.ModelNumber &&
      this.quoteSummary.ProductLineCode &&
      this.quoteSummary.PlantNumber
    ) {
      return (
        !isPlantUser &&
        this.quoteSummary.ModelNumber.includes('HOU') &&
        this.quoteSummary.ProductLineCode.trim() === 'HA' &&
        this.quoteSummary.PlantNumber === 952
      );
    }
    this.subscription.add(currentUserSub);
  }

  get showDeclineQuoteButton(): boolean {
    return (
      this.currentUserRoles.includes('MyCustomHomes_Quote_Approver') ||
      this.currentUserRoles.includes('MyCustomHomes_OverrideApprover')
    );
  }

  get disableSubmitForApprovalButton(): boolean {
    return (
      this.quoteSummary.QuoteStatusesID ===
        Constants.QuoteApprovalStatus.PENDING_APPROVAL ||
      this.quoteSummary.QuoteStatusesID ===
        Constants.QuoteApprovalStatus.DECLINED ||
      this.quoteSummary.QuoteStatusesID ==
        Constants.QuoteApprovalStatus.ACCEPTED ||
      !this.currentUser.isMCHUser
    );
  }

  get disableDeclineQuoteButton(): boolean {
    return (
      this.quoteSummary.QuoteStatusesID ===
        Constants.QuoteApprovalStatus.DECLINED ||
      this.quoteSummary.QuoteStatusesID ==
        Constants.QuoteApprovalStatus.ACCEPTED
    );
  }

  get disableApprovalButton(): boolean {
    return (
      this.quoteSummary.QuoteStatusesID ===
        Constants.QuoteApprovalStatus.DECLINED ||
      this.quoteSummary.QuoteStatusesID ==
        Constants.QuoteApprovalStatus.ACCEPTED
    );
  }

  toggleDeclineQuoteModal() {
    this.showDeclineQuoteModal = !this.showDeclineQuoteModal;
    this.browserWidthService.setScroll(this.showDeclineQuoteModal);
  }

  /// Validates the emails entered in the email quote view
  validateEmail(emails: string): boolean {
    let result;
    if (emails && emails.includes(',')) {
      let arr = emails.split(',');
      arr.forEach(x => {
        let re = /\S+@\S+\.\S+/;
        re.test(x) ? (result = true) : (result = false);
      });
      return result;
    } else {
      let re = /\S+@\S+\.\S+/;
      re.test(emails) ? (result = true) : (result = false);
      return result;
    }
  }

  /// Opens/Closes the email quote view
  toggleEmailQuote() {
    this.showEmailPage = !this.showEmailPage;
    this.emails = '';
    this.browserWidthService.setScroll(this.showEmailPage);
    this.browserWidthService.modalActive$.next(this.showEmailPage);
  }

  /// Emails the QuoteSummary pdf to the entered email addresses
  emailQuote(emails: string, submitQuote: boolean = undefined) {
    this.spinner.showSpinner();
    this.disableButton = true;
    this.createPdf();
    const pdfGenerator = this.pdfMake.createPdf(this.pdf);
    pdfGenerator.getBase64(x => {
      if (x !== null && submitQuote !== undefined) {
        let bodyObj = {
          emails: emails.replace(/\s/g, ''),
          attachment: x,
          fileName: `Clayton-Homes-Quote-${this.quoteSummary.QuoteId}.pdf`,
          quantity: this.orderQuantity || 0,
          retailerName: this.retailerName || '',
          retailerNumber: this.retailerNumber || '',
          submitQuote: submitQuote
        };
        this.quoteService.sendPdf(bodyObj).subscribe(
          x => {
            if (x === true) {
              this.toast = {
                type: 'success',
                title: 'Success',
                body: `Email has been sent!`,
                onShowCallback: toast => {
                  this.spinner.hideSpinner();
                },
                onHideCallback: toast => {
                  (this.showEmailPage = false),
                    (this.emails = ''),
                    (this.showSubmitModal = false),
                    this.browserWidthService.modalActive$.next(false);
                  (this.disableButton = false), (this.orderQuantity = 1);
                },
                timeout: 2000
              };
              this.toasterService.pop(this.toast);
            } else {
              // if error hide spinner
              this.spinner.hideSpinner();
            }
          },
          error => {
            this.spinner.hideSpinner();
            this.httpResponseService.httpErrorResponse$.next(error);
          },
          () => {
            this.spinner.hideSpinner();
          }
        );
      }
    });
    const currentUserSub = this.currentUserService.currentUser$.subscribe(x => {
      this.retailerName = x.retailerName;
      this.retailerNumber = x.retailerNumber;
    });
    this.subscription.add(currentUserSub);
  }

  /// Gets the temp retailer logo
  getBase64Logo() {
    return this.quoteService.getBase64Logo();
  }

  // Returns watermark for pdf if isApproved is false and returns transparent image if true.
  get pdfWatermarkStatus() {
    return this.isApproved ? this.transparentPlaceholderImg : this.pdfWatermark;
  }

  get facilityLogo() {
    return this.quoteSummary.FacilityLogo || this.transparentPlaceholderImg;
  }

  toggleSubmitQuoteModal() {
    this.showSubmitModal = !this.showSubmitModal;
    this.browserWidthService.setScroll(this.showSubmitModal);
    if (this.showSubmitModal === false) {
      this.orderQuantity = 1;
    }
  }

  toggleSubmitForApprovalModal() {
    this.spinner.showSpinner();
    //calculating pricing values for audit purposes
    let BaseCost = this.quoteInfoService.quoteSummary$.value.BaseCost;
    let TotalCost = this.quoteInfoService.quoteSummary$.value.GrandTotal;
    let OptionsTotal = this.quoteInfoService.quoteSummary$.value.OptionsTotal;
    let DuesCost = this.quoteInfoService.quoteSummary$.value.Dues;
    let TaxesCost = this.quoteInfoService.quoteSummary$.value.Taxes;
    let SurchargeCost = this.quoteInfoService.quoteSummary$.value.Surcharge;

    this.quoteApprovalService
      .validateQuote(this.quoteId, this.username)
      .map(x => {
        if (x !== undefined && x !== null && !x.ValidQuote) {
          this.quoteApprovalService.showInvalidQuoteApprovalModal$.next(true);
          this.quoteApprovalService.invalidQuote$.next(x);
          this.disableApproval = true;
        } else {
          this.quoteApprovalService.showInvalidQuoteApprovalModal$.next(false);
          this.showSubmitForApprovalModal = !this.showSubmitForApprovalModal;
          this.browserWidthService.setScroll(this.showSubmitForApprovalModal);
          this.disableApproval = false;
        }
      })
      .subscribe(
        data => {},
        error => {
          this.spinner.hideSpinner();
          this.httpResponseService.httpErrorResponse$.next(error);
        },
        () => {}
      );
  }

  toggleSubmitApprovalHideSpinner() {
    this.spinner.showSpinner();
    //  calculating pricing values for audit purposes
    let BaseCost = this.quoteInfoService.quoteSummary$.value.BaseCost;
    let TotalCost = this.quoteInfoService.quoteSummary$.value.GrandTotal;
    let OptionsTotal = this.quoteInfoService.quoteSummary$.value.OptionsTotal;
    let DuesCost = this.quoteInfoService.quoteSummary$.value.Dues;
    let TaxesCost = this.quoteInfoService.quoteSummary$.value.Taxes;
    let SurchargeCost = this.quoteInfoService.quoteSummary$.value.Surcharge;

    this.quoteApprovalService
      .validateQuote(this.quoteId, this.username)
      .map(x => {
        if (x !== undefined && x !== null && !x.ValidQuote) {
          this.quoteApprovalService.showInvalidQuoteApprovalModal$.next(true);
          this.quoteApprovalService.invalidQuote$.next(x);
          this.disableApproval = true;
        } else {
          this.quoteApprovalService.showInvalidQuoteApprovalModal$.next(false);
          this.showSubmitForApprovalModal = !this.showSubmitForApprovalModal;
          this.browserWidthService.setScroll(this.showSubmitForApprovalModal);
          this.disableApproval = false;
        }
      })
      .subscribe(() => this.spinner.hideSpinner());
  }

  closeSubmitForApprovalModal() {
    this.browserWidthService.setScroll(false);
    this.showSubmitForApprovalModal = false;
  }

  decrementOrderQuantity() {
    this.orderQuantity--;
  }

  incrementOrderQuantity() {
    this.orderQuantity++;
  }

  closeSubmitQuoteForApprovalModal(value: boolean) {
    if (value) {
      this.submitQuoteForApproval();
      this.toggleSubmitForApprovalModal();
    } else {
      // do nothing
      this.closeSubmitForApprovalModal();
    }
  }

  closeDeclineModal() {
    this.browserWidthService.setScroll(false);
    this.showDeclineQuoteModal = false;
  }

  closeDeclineQuoteModal(value: boolean) {
    if (value) {
      // send email to retailer that the quote has been declined.
      this.declineQuote();
      this.toggleDeclineQuoteModal();
    } else {
      // do nothing
      this.closeDeclineModal();
    }
  }

  closeSubmitQuoteModal(value: boolean) {
    if (value) {
      this.submitQuoteAddress =
        window.location.href.toUpperCase().includes('DEV') ||
        window.location.href.toUpperCase().includes('ITG') ||
        window.location.href.toUpperCase().includes('QUA')
          ? 'MfgQATest@ClaytonHomes.com'
          : this.quoteSummary.SalesEmail;
      let validEmail = this.validateEmail(this.submitQuoteAddress);
      if (validEmail) {
        this.emailQuote(this.submitQuoteAddress, true);
      } else {
        this.validSubmitQuoteAddress = false;
      }
    } else {
      this.orderQuantity = 1;
      this.toggleSubmitQuoteModal();
    }
  }

  setErrorStatus(e) {
    this.throwErrorForTesting = e.target.checked;
  }

  submitQuoteForApproval() {
    this.spinner.showSpinner();
    if (this.throwErrorForTesting) {
      this.throwErrorToast();
    } else {
      this.applicationStateService.setQuotePricing(
        this.quoteSummary.BaseCost,
        this.quoteSummary.ModelBaseOverride,
        this.quoteSummary.Dues,
        this.quoteSummary.OptionsTotal,
        this.quoteSummary.VIPAmount,
        this.quoteSummary.PartnerAssistanceAmount,
        this.quoteSummary.Surcharge,
        this.quoteSummary.Taxes,
        this.quoteSummary.Transportation,
        this.quoteSummary.GrandTotal
      );

      const setQuoteStatus = this.applicationStateService
        .setQuoteStatus(Constants.QuoteApprovalStatus.PENDING_APPROVAL)
        .subscribe(
          x => {
            let email: string =
              window.location.href.toUpperCase().includes('DEV') ||
              window.location.href.toUpperCase().includes('ITG') ||
              window.location.href.toUpperCase().includes('QUA')
                ? 'MfgQATest@ClaytonHomes.com'
                : this.quoteSummary.SalesEmail;
            this.quoteApprovalService
              .sendSubmitApprovalEmail(this.quoteId, email)
              .subscribe(
                status => {
                  if (status.json() === 'done' && !this.throwErrorForTesting) {
                    this.quoteSummary.QuoteStatusesID =
                      Constants.QuoteApprovalStatus.PENDING_APPROVAL;
                    this.toasterService.pop({
                      type: 'success',
                      title: 'Success!',
                      body: `Quote ${
                        this.quoteId
                      } has been submitted for approval.`
                    });
                  }
                },
                error => {
                  this.spinner.hideSpinner();
                  this.httpResponseService.httpErrorResponse$.next(error);
                },
                () => this.spinner.hideSpinner()
              );
          },
          error => {
            this.spinner.hideSpinner();
            this.httpResponseService.httpErrorResponse$.next(error);
          },
          () => {}
        );
      this.subscription.add(setQuoteStatus);
    }
  }

  declineQuote() {
    this.spinner.showSpinner();
    const setQuoteStatus = this.applicationStateService
      .setQuoteStatus(
        Constants.QuoteApprovalStatus.DECLINED,
        this.declinedReason
      )
      .subscribe(
        y => {
          this.quoteApprovalService.sendApprovalEmail(this.quoteId).subscribe(
            status => {
              if (status.json() === 'done' && !this.throwErrorForTesting) {
                this.quoteSummary.QuoteStatusesID =
                  Constants.QuoteApprovalStatus.DECLINED;
                this.spinner.hideSpinner();
                this.toasterService.pop(
                  'success',
                  'Success!',
                  `Quote ${this.quoteId} has been declined.`
                );
              } else {
                if (!this.throwErrorForTesting) {
                  this.quoteSummary.QuoteStatusesID =
                    Constants.QuoteApprovalStatus.DECLINED;
                  this.throwErrorToast();
                  this.throwErrorForTesting = false;
                  this.spinner.hideSpinner();
                }
              }
              if (this.throwErrorForTesting) {
                this.quoteSummary.QuoteStatusesID =
                  Constants.QuoteApprovalStatus.DECLINED;
                this.throwErrorToast();
                this.throwErrorForTesting = false;
                this.spinner.hideSpinner();
              }
            },
            error => {
              this.spinner.hideSpinner();
              this.httpResponseService.httpErrorResponse$.next(error);
            },
            () => {
              this.spinner.hideSpinner();
            }
          );
        },
        error => {
          this.spinner.hideSpinner();
          this.httpResponseService.httpErrorResponse$.next(error);
        },
        () => {}
      );
    this.subscription.add(setQuoteStatus);
  }

  /// Gets the watermark for non-approved quotes
  createPdf() {
    const facilityPhone = this.phoneNumberPipe.transform(
      this.quoteSummary.FacilityPhone
    );
    const facilityFax = this.phoneNumberPipe.transform(
      this.quoteSummary.FacilityFax
    );
    this.pdf = {
      background: {
        image: this.pdfWatermarkStatus,
        width: 577,
        margin: [0, 150, 0, 0]
      },
      footer: {
        table: {
          headerRows: 0,
          body: [
            [
              '*This is a price estimate, price is subject to change based on manufacturing facility review and final price quote and may be higher when you place your order from your home.  Estimated sales price does not include delivery and installation, or other costs such as taxes, title fees, insurance premiums, filing or recording fees, land or improvements to land, optional home features not listed, wheels and axles, community or homeowner association fees, or any other items not shown on your Sales Agreement, Retailer Closing Agreement, and related documents (your SA/RCA). Your SA/RCA will show the details of your purchase.  This price estimate only valid at the home center that provided the price estimate.'
            ]
          ]
        },
        margin: [30, 0, 30, 10],
        fontSize: 6.5
      },
      content: [
        {
          columns: [
            {
              text: `${this.removeUnicode(
                this.getPrintedDateTime(this.quoteSummary.DateCreated)
              )}`,
              alignment: 'left',
              fontSize: this.mediumPdfFontSize,
              bold: true
            },
            {
              width: '50%',
              text: 'Build A Quote | Estimated Quote Summary',
              alignment: 'center',
              fontSize: this.mediumPdfFontSize,
              bold: true
            },
            {
              text: `Quote Number ${this.quoteSummary.QuoteId}`,
              alignment: 'right',
              fontSize: this.mediumPdfFontSize,
              bold: true
            }
          ]
        },
        {
          columns: this.pdfHeader
        },
        {
          text:
            'Price does not include required site delivery and installation. Installed price will be higher. *See below.',
          alignment: 'right',
          fontSize: this.defaultPdfFontSize
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 514,
              y2: 0,
              lineWidth: 2
            }
          ]
        },
        {
          columns: this.pdfPricingHeader
        },
        {
          columns: this.pdfHeaderLines
        },
        {
          columns: this.pdfHeaderInfo
        }
      ]
    };

    if (
      this.quoteSummary.Transportation <= 0 &&
      this.currentPricingView !== 3
    ) {
      this.pdf.content.push({
        text: `*** Freight cost NOT included on quote.***`,
        margin: [0, 10, 0, 0],
        fontSize: this.mediumPdfFontSize,
        color: '#ff0000'
      });
      this.pdf.content.push({
        text: `Please submit quote for approval for the facility to input estimated freight cost.`,
        margin: [0, 0, 0, 0],
        fontSize: this.mediumPdfFontSize,
        color: '#ff0000'
      });
    }

    if (this.quoteSummary !== undefined && this.quoteSummary !== null) {
      if (
        this.quoteSummary.Options !== undefined &&
        this.quoteSummary.Options !== null &&
        this.quoteSummary.Options.length > 0
      ) {
        this.pdf.content.push({
          text: `Home Specs`,
          margin: [0, 10, 0, 10],
          fontSize: this.mediumPdfFontSize
        });
      }
    }

    let pdfParagraphs = this.optionsArray.map(x => {
      let paragraph = {
        table: {
          headerRows: 1,
          widths:
            this.applicationStateService.pricingView === 3
              ? [28, '*', 20, 0]
              : [28, '*', 20, 45],
          body: this.buildPdfOptionsTable(
            x.options,
            x.category.trim(),
            x.categoryMessages[0]
          )
        },
        layout: 'headerLineOnly',
        width: '50%',
        margin: [0, 0, 0, 15],
        rowCount:
          this.getOptionsLength(x.options) +
          this.getCategoryMessagesLength(x.categoryMessages[0])
      };
      return paragraph;
    });

    const arrLeft = [];
    const arrRight = [];
    const pdfRows = [];
    let totalRows = 0;
    pdfParagraphs.map(x => (totalRows += x.rowCount));
    let cumulativeRowsLeft = 0;
    let cumulativeRowsRight = 0;
    pdfParagraphs.forEach((p, i) => {
      if (i % 2 === 0 && cumulativeRowsLeft < totalRows / 2) {
        arrLeft.push(p);
        cumulativeRowsLeft += p.rowCount;
      } else {
        arrRight.push(p);
        cumulativeRowsRight += p.rowCount;
      }
    });
    pdfRows.push(arrLeft);
    pdfRows.push(arrRight);
    this.pdf.content.push({ columns: pdfRows, columnGap: 8 });

    /// Custom Options Only
    if (
      this.customOptions !== undefined &&
      this.customOptions !== null &&
      this.customOptions.length > 0
    ) {
      let customOptionPdfParagraphs = {
        table: {
          headerRows: 1,
          widths:
            this.applicationStateService.pricingView === 3
              ? [28, '*', 20, 0]
              : [28, '*', 20, 37],
          body: this.buildPdfCustomOptionsTable(this.customOptions)
        },
        layout: 'headerLineOnly',
        width: '50%',
        margin: [0, 0, 0, 15]
      };
      this.pdf.content.push(customOptionPdfParagraphs);
    }
  }

  getCategoryMessagesLength(messages: string) {
    if (messages !== undefined && messages.length > 0) {
      return messages.split(', ').length;
    } else {
      return 0;
    }
  }

  getOptionsLength(options: Array<any>) {
    if (options.length > 0) {
      return options.length;
    } else {
      return 0;
    }
  }

  buildPdfOptionsTable(
    options: Array<any>,
    category: string,
    categorymessages: string
  ) {
    let outer = [];
    let header = [
      {
        text: `${category}`,
        alignment: 'left',
        colSpan: 2,
        fontSize: this.defaultPdfFontSize,
        bold: true
      },
      { text: ``, alignment: 'left', fontSize: this.defaultPdfFontSize },
      { text: 'Qty', alignment: 'right', fontSize: this.defaultPdfFontSize },
      { text: 'Price', alignment: 'right', fontSize: this.defaultPdfFontSize }
    ];
    this.checkForPricing(header);
    outer.push(header);
    if (categorymessages !== undefined && categorymessages.length > 0) {
      categorymessages.split(', ').forEach(catDesc => {
        let catHeader = [
          { text: ``, alignment: 'left', fontSize: this.defaultPdfFontSize },
          {
            text: `${catDesc.trim()}`,
            alignment: 'left',
            colSpan: 2,
            fontSize: this.defaultPdfFontSize
          },
          { text: ``, alignment: 'right', fontSize: this.defaultPdfFontSize },
          { text: ``, alignment: 'right', fontSize: this.defaultPdfFontSize }
        ];
        outer.push(catHeader);
      });
    }

    for (let i = 0; i < options.length; i++) {
      let isSubOption = options[i].WasChanged === true;
      if (options[i].IsCustomOption) {
        let temp1 = [
          {
            text: this.sixDigitsPipe.transform(Number(options[i].OptionNumber)),
            alignment: 'left',
            fontSize: this.defaultPdfFontSize,
            fillColor: this.getFillColor(options[i])
          },
          {
            text: `${options[i].OptionDesc.trim()}`,
            alignment: 'left',
            fontSize: `${
              isSubOption ? this.subOptionPdfFontSize : this.defaultPdfFontSize
            }`,
            bold: isSubOption,
            fillColor: this.getFillColor(options[i])
          },
          {
            text: options[i].Quantity,
            alignment: 'right',
            fontSize: this.defaultPdfFontSize,
            fillColor: this.getFillColor(options[i])
          },
          {
            text: this.currencyPipe.transform(
              options[i].AdjustedTotalPrice,
              'USD',
              'symbol-narrow',
              '1.2-2'
            ),
            alignment: 'right',
            fontSize: this.defaultPdfFontSize,
            fillColor: this.getFillColor(options[i])
          }
        ];
        this.checkForPricing(temp1);
        outer.push(temp1);
        if (options[i].Note) {
          let optNote = [
            { text: ``, alignment: 'left', fontSize: this.defaultPdfFontSize },
            {
              text: `User Note: ${options[i].Note.trim()}`,
              alignment: 'left',
              colSpan: 3,
              fontSize: `${this.defaultPdfFontSize}`,
              bold: false
            },
            { text: ``, alignment: 'right', fontSize: this.defaultPdfFontSize },
            { text: ``, alignment: 'right', fontSize: this.defaultPdfFontSize }
          ];
          outer.push(optNote);
        }
      } else {
        let temp2 = [
          {
            text: options[i].OptionNumber,
            alignment: 'left',
            fontSize: this.defaultPdfFontSize,
            fillColor: this.getFillColor(options[i])
          },
          {
            text: `${options[i].OptionDesc.trim()}`,
            alignment: 'left',
            fontSize: `${
              isSubOption ? this.subOptionPdfFontSize : this.defaultPdfFontSize
            }`,
            bold: isSubOption,
            fillColor: this.getFillColor(options[i])
          },
          {
            text: options[i].Quantity,
            alignment: 'right',
            fontSize: this.defaultPdfFontSize,
            fillColor: this.getFillColor(options[i])
          },
          {
            text: this.currencyPipe.transform(
              options[i].AdjustedTotalPrice,
              'USD',
              'symbol-narrow',
              '1.2-2'
            ),
            alignment: 'right',
            fontSize: this.defaultPdfFontSize,
            fillColor: this.getFillColor(options[i])
          }
        ];
        this.checkForPricing(temp2);
        outer.push(temp2);
        if (options[i].Note) {
          let optdesc = [
            {
              text: ``,
              alignment: 'left',
              fontSize: this.defaultPdfFontSize,
              fillColor: this.getFillColor(options[i])
            },
            {
              text: `User Note: ${options[i].Note.trim()}`,
              alignment: 'left',
              colSpan: 3,
              fontSize: `${this.defaultPdfFontSize}`,
              bold: false,
              fillColor: this.getFillColor(options[i])
            },
            {
              text: ``,
              alignment: 'right',
              fontSize: this.defaultPdfFontSize,
              fillColor: this.getFillColor(options[i])
            },
            {
              text: ``,
              alignment: 'right',
              fontSize: this.defaultPdfFontSize,
              fillColor: this.getFillColor(options[i])
            }
          ];
          outer.push(optdesc);
        }
      }
    }
    return outer;
  }

  getFillColor(option: SelectedOption) {
    return option.ChangedByFacility === true ? '#ffffb8' : '#ffffff';
  }

  buildPdfCustomOptionsTable(options: Array<any>) {
    let outer = [];
    let header = [
      {
        text: `CUSTOM SPECS`,
        alignment: 'left',
        colSpan: 2,
        fontSize: this.defaultPdfFontSize,
        bold: true
      },
      { text: ``, alignment: 'left', fontSize: this.defaultPdfFontSize },
      { text: 'Qty', alignment: 'right', fontSize: this.defaultPdfFontSize },
      { text: 'Price', alignment: 'right', fontSize: this.defaultPdfFontSize }
    ];
    this.checkForPricing(header);
    outer.push(header);
    for (let i = 0; i < options.length; i++) {
      let temp1 = [
        {
          text: this.sixDigitsPipe.transform(Number(options[i].OptionNumber)),
          alignment: 'left',
          fontSize: this.defaultPdfFontSize,
          fillColor: this.getFillColor(options[i])
        },
        {
          text: `${options[i].OptionDesc.trim()}`,
          alignment: 'left',
          fontSize: `${this.defaultPdfFontSize}`,
          bold: false,
          fillColor: this.getFillColor(options[i])
        },
        {
          text: options[i].Quantity,
          alignment: 'right',
          fontSize: this.defaultPdfFontSize,
          fillColor: this.getFillColor(options[i])
        },
        {
          text: this.currencyPipe.transform(
            options[i].AdjustedTotalPrice,
            'USD',
            'symbol-narrow',
            '1.2-2'
          ),
          alignment: 'right',
          fontSize: this.defaultPdfFontSize,
          fillColor: this.getFillColor(options[i])
        }
      ];
      this.checkForPricing(temp1);
      outer.push(temp1);
      if (options[i].Note) {
        let optNote = [
          {
            text: ``,
            alignment: 'left',
            fontSize: this.defaultPdfFontSize,
            fillColor: this.getFillColor(options[i])
          },
          {
            text: `User Note: ${options[i].Note.trim()}`,
            alignment: 'left',
            colSpan: 3,
            fontSize: `${this.defaultPdfFontSize}`,
            bold: false,
            fillColor: this.getFillColor(options[i])
          },
          {
            text: ``,
            alignment: 'right',
            fontSize: this.defaultPdfFontSize,
            fillColor: this.getFillColor(options[i])
          },
          {
            text: ``,
            alignment: 'right',
            fontSize: this.defaultPdfFontSize,
            fillColor: this.getFillColor(options[i])
          }
        ];
        outer.push(optNote);
      }
    }
    return outer;
  }

  checkForPricing(option) {
    if (this.applicationStateService.pricingView === 3) {
      return option.splice(option.length - 1, 1);
    } else {
      return option;
    }
  }

  get pdfPricingHeader() {
    if (this.applicationStateService.pricingView === 3) {
      return [
        {
          text: 'Retailer Information',
          margin: [0, 5],
          fontSize: this.mediumPdfFontSize
        },
        {
          text: 'Facility Information',
          margin: [0, 5],
          fontSize: this.mediumPdfFontSize
        }
      ];
    } else {
      return [
        {
          text: 'Retailer Information',
          margin: [0, 5],
          fontSize: this.mediumPdfFontSize
        },
        {
          text: 'Estimated Pricing Information',
          margin: [0, 5],
          fontSize: this.mediumPdfFontSize
        },
        {
          text: 'Facility Information',
          margin: [0, 5],
          fontSize: this.mediumPdfFontSize
        }
      ];
    }
  }

  get pdfHeaderLines() {
    if (this.applicationStateService.pricingView === 3) {
      return [
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 244,
              y2: 0,
              lineWidth: 1
            }
          ]
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 250,
              y2: 0,
              lineWidth: 1
            }
          ]
        }
      ];
    } else {
      return [
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 163,
              y2: 0,
              lineWidth: 1
            }
          ]
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 163,
              y2: 0,
              lineWidth: 1
            }
          ]
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 170,
              y2: 0,
              lineWidth: 1
            }
          ]
        }
      ];
    }
  }

  get pdfHeaderInfo() {
    if (this.applicationStateService.pricingView === 3) {
      return [
        {
          table: {
            headerRows: 0,
            body: [
              [
                {
                  text: `For: ${this.quoteSummary.CustomerName}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `${this.wordCasePipe.transform(
                    this.quoteSummary.RetailerName
                  )}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `${this.wordCasePipe.transform(
                    this.quoteSummary.RetailerAddress
                  )}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `Phone: ${this.phoneNumberPipe.transform(
                    this.quoteSummary.RetailerPhone
                  ) || 'Not Available'}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `Retailer #: ${this.quoteSummary.RetailerNumber}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `Model: ${this.wordCasePipe.transform(
                    this.quoteSummary.ModelName
                  )}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `Model #: ${this.quoteSummary.ModelNumber}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `Ordered By: ${this.quoteSummary.OrderedBy ||
                    'Not Available'}`,
                  fontSize: this.defaultPdfFontSize
                }
              ]
            ]
          },
          layout: 'noBorders',
          margin: [0, 7, 0, 0],
          columnGap: 15
        },
        {
          table: {
            headerRows: 0,
            body: [
              [
                {
                  text: `${this.quoteSummary.FacilityName}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `${this.wordCasePipe.transform(
                    this.quoteSummary.FacilityAddress
                  )}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `Phone: ${this.phoneNumberPipe.transform(
                    this.quoteSummary.FacilityPhone
                  ) || 'Not Available'}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `Fax: ${this.phoneNumberPipe.transform(
                    this.quoteSummary.FacilityFax
                  ) || 'Not Available'}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `Sales Rep: ${this.wordCasePipe.transform(
                    this.quoteSummary.SalesRep
                  ) || 'Not Available'}`,
                  fontSize: this.defaultPdfFontSize
                }
              ]
            ]
          },
          layout: 'noBorders',
          margin: [0, 7, 0, 0],
          columnGap: 15
        }
      ];
    } else {
      return [
        {
          table: {
            headerRows: 0,
            body: [
              [
                {
                  text: `For: ${this.quoteSummary.CustomerName}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `${this.wordCasePipe.transform(
                    this.quoteSummary.RetailerName
                  )}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `${this.wordCasePipe.transform(
                    this.quoteSummary.RetailerAddress
                  )}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `Phone: ${this.phoneNumberPipe.transform(
                    this.quoteSummary.RetailerPhone
                  ) || 'Not Available'}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `Retailer #: ${this.quoteSummary.RetailerNumber}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `Model: ${this.wordCasePipe.transform(
                    this.quoteSummary.ModelName
                  )}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `Model #: ${this.quoteSummary.ModelNumber}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `Ordered By: ${this.quoteSummary.OrderedBy ||
                    'Not Available'}`,
                  fontSize: this.defaultPdfFontSize
                }
              ]
            ]
          },
          layout: 'noBorders',
          margin: [0, 7, 0, 0],
          columnGap: 15
        },
        {
          table: {
            headerRows: 0,
            body: this.pdfPricingColumn
          },
          layout: 'noBorders',
          margin: [0, 7, 0, 0],
          columnGap: 15
        },
        {
          table: {
            headerRows: 0,
            body: [
              [
                {
                  text: `${this.quoteSummary.FacilityName}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text: `${this.wordCasePipe.transform(
                    this.quoteSummary.FacilityAddress
                  )}`,
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text:
                    this.applicationStateService.pricingView !== 1
                      ? `Phone: ${this.phoneNumberPipe.transform(
                          this.quoteSummary.FacilityPhone
                        ) || 'Not Available'}`
                      : '',
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text:
                    this.applicationStateService.pricingView !== 1
                      ? `Fax: ${this.phoneNumberPipe.transform(
                          this.quoteSummary.FacilityFax
                        ) || 'Not Available'}`
                      : '',
                  fontSize: this.defaultPdfFontSize
                }
              ],
              [
                {
                  text:
                    this.applicationStateService.pricingView !== 1
                      ? `Sales Rep: ${this.wordCasePipe.transform(
                          this.quoteSummary.SalesRep
                        ) || 'Not Available'}`
                      : '',
                  fontSize: this.defaultPdfFontSize
                }
              ]
            ]
          },
          layout: 'noBorders',
          margin: [0, 7, 0, 0],
          columnGap: 15
        }
      ];
    }
  }

  get pdfHeader() {
    if (this.quoteSummary.FacilityLogo) {
      return [
        {
          image: this.quoteSummary.FacilityLogo,
          width: 100,
          margin:
            this.applicationStateService.pricingView === 3
              ? [0, 10, 0, 10]
              : [0, 10, 0, 0],
          alignment: 'left'
        },
        {
          text: this.approvalStatusMessage,
          alignment: 'center',
          fontSize: this.largePdfFontSize,
          color: this.approvalStatusMessageStyle,
          width: '*',
          margin: [0, 17, 0, 0]
        },
        {
          text:
            this.applicationStateService.pricingView === 3
              ? ''
              : `Estimated Total: ${this.currencyPipe.transform(
                  this.quoteSummary.GrandTotal,
                  'USD',
                  'symbol-narrow',
                  '1.0-0'
                )}*`,
          alignment: 'right',
          fontSize: this.largePdfFontSize,
          width: 'auto',
          margin: [0, 17, 0, 0]
        }
      ];
    } else {
      return [
        {
          image: this.transparentPlaceholderImg,
          width: this.approvalStatusMessage !== '' ? 100 : 1,
          height: 1,
          margin:
            this.applicationStateService.pricingView === 3
              ? [0, 10, 0, 10]
              : [0, 10, 0, 0]
        },
        {
          text: this.approvalStatusMessage,
          alignment: 'center',
          fontSize: this.largePdfFontSize,
          color: this.approvalStatusMessageStyle,
          width: '*',
          margin: [0, 17, 0, 0]
        },
        {
          text:
            this.applicationStateService.pricingView === 3
              ? ''
              : `Estimated Total: ${this.currencyPipe.transform(
                  this.quoteSummary.GrandTotal,
                  'USD',
                  'symbol-narrow',
                  '1.0-0'
                )}*`,
          alignment: 'right',
          fontSize: this.largePdfFontSize,
          margin: [0, 17, 0, 0],
          width: 'auto'
        }
      ];
    }
  }

  // Returns the appropriate pricing column based on the selected pricing view.
  get pdfPricingColumn() {
    // Customer View
    if (this.applicationStateService.pricingView === 1) {
      return [
        [
          {
            text: 'Home Price:',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.consolidatedPricing,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
        ],
        [
          {
            text: 'Options Total:',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.OptionsTotal,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
        ],
        [
          {
            text: 'Shipping, Handling, Destination:',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.Transportation,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
          ],
          [
              {
                  text: 'VIP Discount:',
                  fontSize: this.defaultPdfFontSize,
                  alignment: 'left'
              },
              {
                  text: `${this.currencyPipe.transform(
                      this.quoteSummary.VIPAmount,
                      'USD',
                      'symbol-narrow',
                      '1.0-0'
                  )}`,
                  fontSize: this.defaultPdfFontSize,
                  alignment: 'right'
              }
          ],
          [
              {
                  text: 'Partner Assistance Amount:',
                  fontSize: this.defaultPdfFontSize,
                  alignment: 'left'
              },
              {
                  text: `${this.currencyPipe.transform(
                      this.quoteSummary.PartnerAssistanceAmount,
                      'USD',
                      'symbol-narrow',
                      '1.0-0'
                  )}`,
                  fontSize: this.defaultPdfFontSize,
                  alignment: 'right'
              }
          ],
        [
          {
            text: 'Estimated Total',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.GrandTotal,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}*`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
        ]
      ];
    }

    // Facility View both vip and partner not null
    if (
      this.applicationStateService.pricingView === 2 &&
      this.quoteSummary.VIPAmount !== 0 && this.quoteSummary.PartnerAssistanceAmount !== 0
    ) {
      return [
        [
          {
            text: 'Base Price:',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.BaseCost,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
        ],
        [
          {
            text: 'Options Total:',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.OptionsTotal,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
        ],
        [
          {
            text: 'Shipping, Handling, Dest:',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left',
            color: this.quoteSummary.Transportation <= 0 ? '#ff0000' : null,
            bold: this.quoteSummary.Transportation <= 0 ? true : false
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.Transportation,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right',
            color: this.quoteSummary.Transportation <= 0 ? '#ff0000' : null,
            bold: this.quoteSummary.Transportation <= 0 ? true : false
          }
        ],
        [
          {
            text: 'Taxes(Modular & Wholesale):',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.Taxes,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
        ],
        [
          {
            text: 'Dues(MHI, State, Association):',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.Dues,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
        ],
        [
          {
            text: 'VIP Discount:',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.VIPAmount,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
        ],
        [
            {
                text: 'Partner Assistance Amount:',
                fontSize: this.defaultPdfFontSize,
                alignment: 'left'
            },
            {
                text: `${this.currencyPipe.transform(
                    this.quoteSummary.PartnerAssistanceAmount,
                    'USD',
                    'symbol-narrow',
                    '1.0-0'
                )}`,
                fontSize: this.defaultPdfFontSize,
                alignment: 'right'
            }
        ],
        [
          {
            text: 'Estimated Total',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.GrandTotal,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}*`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
        ]
      ];
    }

    if (
      this.applicationStateService.pricingView === 2 &&
      this.quoteSummary.VIPAmount === 0 && this.quoteSummary.PartnerAssistanceAmount === 0
    ) {
      return [
        [
          {
            text: 'Base Price:',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.BaseCost,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
        ],
        [
          {
            text: 'Options Total:',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.OptionsTotal,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
        ],
        [
          {
            text: 'Shipping, Handling, Dest:',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left',
            color: this.quoteSummary.Transportation <= 0 ? '#ff0000' : null,
            bold: this.quoteSummary.Transportation <= 0 ? true : false
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.Transportation,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right',
            color: this.quoteSummary.Transportation <= 0 ? '#ff0000' : null,
            bold: this.quoteSummary.Transportation <= 0 ? true : false
          }
        ],
        [
          {
            text: 'Taxes(Modular & Wholesale):',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.Taxes,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
        ],
        [
          {
            text: 'Dues(MHI, State, Association):',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.Dues,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
          ],
        [
          {
            text: 'Estimated Total',
            fontSize: this.defaultPdfFontSize,
            alignment: 'left'
          },
          {
            text: `${this.currencyPipe.transform(
              this.quoteSummary.GrandTotal,
              'USD',
              'symbol-narrow',
              '1.0-0'
            )}*`,
            fontSize: this.defaultPdfFontSize,
            alignment: 'right'
          }
        ]
      ];
      }
      if (
          this.applicationStateService.pricingView === 2 &&
          this.quoteSummary.VIPAmount !== 0 && this.quoteSummary.PartnerAssistanceAmount === 0
      ) {
          return [
              [
                  {
                      text: 'Base Price:',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left'
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.BaseCost,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right'
                  }
              ],
              [
                  {
                      text: 'Options Total:',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left'
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.OptionsTotal,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right'
                  }
              ],
              [
                  {
                      text: 'Shipping, Handling, Dest:',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left',
                      color: this.quoteSummary.Transportation <= 0 ? '#ff0000' : null,
                      bold: this.quoteSummary.Transportation <= 0 ? true : false
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.Transportation,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right',
                      color: this.quoteSummary.Transportation <= 0 ? '#ff0000' : null,
                      bold: this.quoteSummary.Transportation <= 0 ? true : false
                  }
              ],
              [
                  {
                      text: 'Taxes(Modular & Wholesale):',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left'
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.Taxes,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right'
                  }
              ],
              [
                  {
                      text: 'Dues(MHI, State, Association):',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left'
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.Dues,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right'
                  }
              ],
              [
                  {
                      text: 'VIP Discount:',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left'
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.VIPAmount,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right'
                  }
              ],
              [
                  {
                      text: 'Estimated Total',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left'
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.GrandTotal,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}*`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right'
                  }
              ]
          ];
      }
      if (
          this.applicationStateService.pricingView === 2 &&
          this.quoteSummary.VIPAmount === 0 && this.quoteSummary.PartnerAssistanceAmount !== 0
      ) {
          return [
              [
                  {
                      text: 'Base Price:',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left'
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.BaseCost,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right'
                  }
              ],
              [
                  {
                      text: 'Options Total:',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left'
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.OptionsTotal,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right'
                  }
              ],
              [
                  {
                      text: 'Shipping, Handling, Dest:',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left',
                      color: this.quoteSummary.Transportation <= 0 ? '#ff0000' : null,
                      bold: this.quoteSummary.Transportation <= 0 ? true : false
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.Transportation,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right',
                      color: this.quoteSummary.Transportation <= 0 ? '#ff0000' : null,
                      bold: this.quoteSummary.Transportation <= 0 ? true : false
                  }
              ],
              [
                  {
                      text: 'Taxes(Modular & Wholesale):',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left'
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.Taxes,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right'
                  }
              ],
              [
                  {
                      text: 'Dues(MHI, State, Association):',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left'
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.Dues,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right'
                  }
              ],
              [
                  {
                      text: 'Partner Assistance:',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left'
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.PartnerAssistanceAmount,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right'
                  }
              ],
              [
                  {
                      text: 'Estimated Total',
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'left'
                  },
                  {
                      text: `${this.currencyPipe.transform(
                          this.quoteSummary.GrandTotal,
                          'USD',
                          'symbol-narrow',
                          '1.0-0'
                      )}*`,
                      fontSize: this.defaultPdfFontSize,
                      alignment: 'right'
                  }
              ]
          ];
      }

    // No Pricing View
    if (this.applicationStateService.pricingView === 3) {
      return [[]];
    }
  }

  get isIe() {
    return (
      !!navigator.userAgent.match(/Trident/g) ||
      !!navigator.userAgent.match(/MSIE/g) ||
      !!navigator.userAgent.match(/Edge/g)
    );
  }

  /// Downloads the QuoteSummary page in the form of a pdf when the Download PDF button is clicked
  downloadPdf() {
    this.createPdf();
    this.pdfMake
      .createPdf(this.pdf)
      .download(`Clayton-Homes-Quote-${this.quoteSummary.QuoteId}.pdf`);
  }

  /// Prints the QuoteSummary page when the print button is clicked
  printQuote() {
    if (!this.isIe) {
      this.createPdf();
      let pdf = this.pdfMake.createPdf(this.pdf);
      pdf.print();
    } else {
      if (isPlatformBrowser) {
        window.print();
      }
    }
  }

  /// Loads a pricing view then recalculates the prices displayed
  loadPricing(quote: Quote) {
    if (quote.modelId > 0) {
      this.calculatePricing(this._quoteSummaryCache, this.quoteAdjustment);
    }
  }

  /// Recalculates the pricing displayed when the pricing view is changed
  calculatePricing(quoteSummaryCache: QuoteSummary, adjustment: Adjustment) {
    let masterModel = this.optionsService.calculatePricing(
      [],
      this.quoteSummary.Options,
      null,
      this.quoteAdjustment,
      this.currentPricingView
    );
    if (
      masterModel.QuoteSelectedOptions !== undefined &&
      masterModel.QuoteSelectedOptions !== null &&
      masterModel.QuoteSelectedOptions.length > 0
    ) {
      masterModel.QuoteSelectedOptions.forEach(mmop => {
        this.quoteSummary.Options.forEach(qsop => {
          if (qsop.SelectedOptionId === mmop.SelectedOptionId) {
            qsop.AdjustedUnitPrice = mmop.AdjustedUnitPrice;
            qsop.AdjustedTotalPrice = mmop.AdjustedTotalPrice;
            qsop.UnitPrice = mmop.UnitPrice;
            qsop.TotalPrice = mmop.UnitPrice * mmop.Quantity;
            qsop.UIUnitPrice =
              mmop.UnitPriceOverride !== undefined &&
              mmop.UnitPriceOverride !== null
                ? mmop.UnitPriceOverride.toString()
                : mmop.UnitPrice.toString();

          }
        });
      });
      quoteSummaryCache.OptionsTotal = 0;
      this.quoteSummary.Options.forEach(qsop => {
        quoteSummaryCache.OptionsTotal += qsop.AdjustedTotalPrice;
      });
      this.customOptions = this.quoteSummary.Options.filter(
        x => x.IsCustomOption === true
      );
    }
    if (this.currentPricingView === 1) {
      if (adjustment !== undefined && adjustment !== null) {
        this.quoteSummary.BaseCost =
          adjustment.baseAdjustmentPercent !== undefined &&
          adjustment.baseAdjustmentPercent !== 0
            ? quoteSummaryCache.BaseCost *
              (1 + adjustment.baseAdjustmentPercent / 100)
            : quoteSummaryCache.BaseCost + adjustment.baseAdjustmentFlat;
          this.quoteSummary.OptionsTotal = quoteSummaryCache.OptionsTotal;
          this.quoteSummary.PartnerAssistanceAmount = quoteSummaryCache.PartnerAssistanceAmount;
          this.quoteSummary.VIPAmount = quoteSummaryCache.VIPAmount;
        this.quoteSummary.GrandTotal =         
            (this.quoteSummary.BaseCost + this.quoteSummary.PartnerAssistanceAmount + this.quoteSummary.VIPAmount) +
          this.quoteSummary.OptionsTotal +
          this.quoteSummary.Surcharge +
          this.quoteSummary.Transportation +
          this.quoteSummary.Dues +
          this.quoteSummary.Taxes;         
      } else {
        // 1.7 below represents the 70% max on base markup or (1 + (70/100))
        this.quoteSummary.BaseCost = quoteSummaryCache.BaseCost * 1.7;
          this.quoteSummary.OptionsTotal = quoteSummaryCache.OptionsTotal;
          this.quoteSummary.PartnerAssistanceAmount = quoteSummaryCache.PartnerAssistanceAmount;
          this.quoteSummary.VIPAmount = quoteSummaryCache.VIPAmount;
        this.quoteSummary.GrandTotal =
        (this.quoteSummary.BaseCost + this.quoteSummary.PartnerAssistanceAmount + this.quoteSummary.VIPAmount) +
          this.quoteSummary.OptionsTotal +
          this.quoteSummary.Surcharge +
          this.quoteSummary.Transportation +
          this.quoteSummary.Dues +
          this.quoteSummary.Taxes;         
      }
    } else {
      this.quoteSummary.BaseCost = quoteSummaryCache.BaseCost;
        this.quoteSummary.OptionsTotal = quoteSummaryCache.OptionsTotal;
        this.quoteSummary.PartnerAssistanceAmount = quoteSummaryCache.PartnerAssistanceAmount;
        this.quoteSummary.VIPAmount = quoteSummaryCache.VIPAmount;
      this.quoteSummary.GrandTotal =
          (this.quoteSummary.BaseCost + this.quoteSummary.PartnerAssistanceAmount + this.quoteSummary.VIPAmount) +
        this.quoteSummary.OptionsTotal +
        this.quoteSummary.Surcharge +
        this.quoteSummary.Transportation +
        this.quoteSummary.Dues +
        this.quoteSummary.Taxes;
     
    }
  }

  redirectRequired(
    newQuotesRedirect: boolean,
    productLinesRedirect: boolean,
    modelsRedirect: boolean
  ) {
    this.stateIsInvalid = false;
    if (newQuotesRedirect) {
      this.router.navigate([Constants.NewQuotesUrl]);
    }
    if (productLinesRedirect) {
      window.location.href = `${this.mchBaseUrl}/${[
        Constants.ProductLineUrl.replace('#quoteid#', this.quoteId.toString())
      ]}`;
    }
    if (modelsRedirect) {
      window.location.href = `${this.mchBaseUrl}/${[
        Constants.ModelUrl.replace('#quoteid#', this.quoteId.toString())
      ]}`;
    }
  }

  displayApprovalModal() {
    this.spinner.showSpinner();
    const validateQuote = this.quoteApprovalService
      .validateQuote(this.quoteId, this.username)
      .map(x => {
        if (x !== undefined && x !== null && !x.ValidQuote) {
          this.quoteApprovalService.showInvalidQuoteApprovalModal$.next(true);
          this.quoteApprovalService.invalidQuote$.next(x);
          this.disableApproval = true;
        } else {
          this.quoteApprovalService.showInvalidQuoteApprovalModal$.next(false);
          this.disableApproval = false;
          this.showApprovalModal = true;
          this.browserWidthService.modalActive$.next(true);
          this.mustOverrideApproval = false;

          // test array of override issues
          this.overrideIssues = new Array<string>();
          this.overrideIssues.push('Base Price changed');
          this.overrideIssues.push('Freight/surcharge override entered');
          this.overrideIssues.push('Custom option added');

          // default expiration date to current date +90 days
          let expirationDate = new Date(
            new Date().setDate(new Date().getDate() + 90)
          );
          this.quoteExpirationDate =
            this.quoteExpirationDate === null || this.quoteExpirationDate === ''
              ? this.removeUnicode(expirationDate.toLocaleDateString())
              : this.quoteExpirationDate;

          this.validateApproval();
        }
      })
      .subscribe(
        data => {},
        error => {
          this.spinner.hideSpinner();
          this.httpResponseService.httpErrorResponse$.next(error);
        },
        () => {
          this.spinner.hideSpinner();
        }
      );
    this.subscription.add(validateQuote);
  }

  cancelApproval() {
    this.showApprovalModal = false;
    this.browserWidthService.modalActive$.next(false);
  }

  toggleApproveQuoteModal() {
    this.showApprovalModal = !this.showApprovalModal;
  }

  approveQuote() {
    this.spinner.showSpinner();
    this.toggleApproveQuoteModal();
    this.browserWidthService.modalActive$.next(false);

    // create iSeries Order first
    let quote: Quote = new Quote();
    quote = this.applicationStateService.getApplicationState().quote;
    const createiSeriesOrder = this.quoteService
      .createiSeriesOrder(quote.quoteId)
      .subscribe(
        iseriesQuoteNumber => {
          // update Quote with new iSeries Order Number
          // console.log(newOrderNumber);
          quote.iseriesQuoteNumber = iseriesQuoteNumber;
          this.quoteSummary.QuoteId = iseriesQuoteNumber;
          this.pageTitleService.pageTitle.next({
            title: Constants.CmhConnectionTitle,
            subTitle: Constants.CurrentQuoteSubTitle + iseriesQuoteNumber
          });
          quote.approvalStatus = Constants.QuoteApprovalStatus.ACCEPTED;
          quote.modifiedBy =
            this.currentUser.cmhUserId +
            ' - ' +
            this.currentUser.firstName +
            ' ' +
            this.currentUser.lastName;
          quote.approvalNote = this.quoteApprovalNote;
          quote.expirationDate = new Date(this.quoteExpirationDate);
          // set pricing
          quote.BaseCost =
            this.quoteSummary.ModelBaseOverride > 0
              ? this.quoteSummary.ModelBaseOverride
              : this.quoteSummary.ModelBaseCost;
          quote.Dues = this.quoteSummary.DuesOnly;
          quote.OptionsTotal = this.quoteSummary.OptionsTotal;
          quote.Surcharge = this.quoteSummary.Surcharge;
          quote.Taxes = this.quoteSummary.Taxes;
          quote.Transportation = this.quoteSummary.Transportation;
          quote.GrandTotal =
            quote.BaseCost +
            quote.OptionsTotal +
            quote.Dues +
            quote.Transportation;

          this.spinner.showSpinner();
          const updateQuoteSub = this.quoteService.updateQuote(quote).subscribe(
            quoteDB => {
              this.quoteInfoService.quote$
                .asObservable()
                .take(1)
                .subscribe(x => {
                  x.ApprovalStatusDescription = 'Approved';
                  this.quoteInfoService.quote$.next(x);
                  this.browserWidthService.modalActive$.next(false);
                });
              this.toasterService.pop(
                'success',
                'Success!',
                `Quote ${this.quoteId} has been updated. 
                AS400 Quote ${iseriesQuoteNumber} created.`
              );
            },
            error => {
              this.spinner.hideSpinner();
              this.toasterService.pop(
                'error',
                'Error!',
                `Errors occurred while approving Quote ${this.quoteId}.`
              );
            },
            () => {
              this.spinner.showSpinner();
              this.isApproved = true;
              const sendApprovalEmailSub = this.quoteApprovalService
                .sendApprovalEmail(this.quoteId)
                .subscribe(
                  status => {
                    if (status.json() === 'done') {
                      this.quoteSummary.QuoteStatusesID =
                        Constants.QuoteApprovalStatus.ACCEPTED;
                      this.spinner.hideSpinner();
                      this.toasterService.pop(
                        'success',
                        'Success!',
                        `Quote ${this.quoteId} has been approved.`
                      );
                    }
                  },
                  error => {
                    this.spinner.hideSpinner();
                    this.toasterService.pop(
                      'error',
                      'Errors!',
                      `Errors occurred while sending approval email.`
                    );
                  }
                );
              this.subscription.add(sendApprovalEmailSub);
            }
          );
          this.subscription.add(updateQuoteSub);
        },
        error => {
          this.spinner.hideSpinner();
          this.toasterService.pop(
            'error',
            'Errors!',
            `Errors occurred while creating AS400 quote.`
          );
        }
      );
    this.subscription.add(createiSeriesOrder);
  }

  validateApproval() {
    this.invalidApprovalData = false;
    this.quoteApprovalNote =
      this.quoteApprovalNote === undefined ? '' : this.quoteApprovalNote;
    this.isvalidExpirationDate = true;
    this.quoteExpirationDate =
      this.quoteExpirationDate === undefined || this.quoteExpirationDate === ''
        ? null
        : this.quoteExpirationDate;
    this.quoteExpirationDate = this.removeUnicode(this.quoteExpirationDate);

    // quote expiration is optional so only validate if entered
    if (this.quoteExpirationDate !== null) {
      // Match the date format through regular expression
      let dateformat = /^(0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])[\/\-]\d{4}$/;
      // Match the date format through regular expression
      if (this.quoteExpirationDate.match(dateformat)) {
        //  Test which seperator is used '/' or '-'
        let opera1 = this.quoteExpirationDate.split('/');
        let opera2 = this.quoteExpirationDate.split('-');
        let lopera1 = opera1.length;
        let lopera2 = opera2.length;
        // Extract the string into month, date and year
        if (lopera1 > 1) {
          var pdate = this.quoteExpirationDate.split('/');
        } else if (lopera2 > 1) {
          var pdate = this.quoteExpirationDate.split('-');
        }
        var mm = parseInt(pdate[0]);
        var dd = parseInt(pdate[1]);
        var yy = parseInt(pdate[2]);
        // Create list of days of a month [assume there is no leap year by default]
        var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (mm == 1 || mm > 2) {
          if (dd > ListofDays[mm - 1]) {
            this.isvalidExpirationDate = false;
          }
        }
        if (mm == 2) {
          var lyear = false;
          if ((!(yy % 4) && yy % 100) || !(yy % 400)) {
            lyear = true;
          }
          if (lyear == false && dd >= 29) {
            this.isvalidExpirationDate = false;
          }
          if (lyear == true && dd > 29) {
            this.isvalidExpirationDate = false;
          }
        }
      } else {
        this.isvalidExpirationDate = false;
      }
    }

    if (this.isvalidExpirationDate && this.quoteExpirationDate !== null) {
      this.quoteExpirationDate = this.removeUnicode(
        new Date(this.quoteExpirationDate).toLocaleDateString()
      );
    }

    if (!this.isvalidExpirationDate) {
      this.invalidApprovalData = true;
    }
  }

  removeUnicode(valueString) {
    return valueString.replace(/\u200E/g, '');
  }

  getPrintedDateTime(dateValue: Date): string {
    let returnValue = dateValue.toLocaleDateString().replace(/[^ -~]/g, '');

    try {
      returnValue +=
        ' ' +
        dateValue
          .toLocaleTimeString()
          .substring(
            0,
            dateValue
              .toLocaleTimeString()
              .indexOf(':', dateValue.toLocaleTimeString().indexOf(':') + 1)
          );
      returnValue +=
        ' ' +
        dateValue
          .toLocaleTimeString()
          .substring(
            dateValue.toLocaleTimeString().length - 2,
            dateValue.toLocaleTimeString().length
          );
    } catch (e) {
      // some error occurred, set the returnValue to undefined
      returnValue = undefined;
    }

    return returnValue;
  }

  get formattedDate() {
    if (this.quoteSummary.DateCreated) {
      return this.removeUnicode(
        this.getPrintedDateTime(this.quoteSummary.DateCreated)
      );
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/quote-summary/quote-summary.component.ts